import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login'
import Home from '@/views/home'
import warningForecast from '@/views/warning-forecast'
import accountPage from '@/views/account'
import rolePermissionManagement from '@/views/role-permission-management'
import staffRoleList from '@/views/staff-role-assignment/staff-role-list'
import staffRoleConfigure from '@/views/staff-role-assignment/staff-role-configure'
import staffRoleConfigureShortcut from '@/views/staff-role-assignment/staff-role-configure-shortcut' // 给采集人员、经销商快捷授权
import jyWeatherStation from '@/views/warning-forecast/jy-weather-station'
import settingPassword from '@/views/settings/password'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: '登录界面'
      }
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: '首页'
      },
      children: [
        {
          path: 'late-blight',
          name: 'late-blight',
          component: () => import('@/views/late-blight/late-blight.vue'),
          meta: {
            title: '河北晚疫病预测'
          }
        },
        {
          path: '/warning-forecast',
          name: 'warning-forecast',
          component: warningForecast,
          meta: {
            title: '中心病株预测'
          }
        },
        {
          path: '/jy-weather-station',
          name: 'jy-weather-station',
          component: jyWeatherStation
        },
        {
          path: '/account',
          name: 'account',
          component: accountPage,
          meta: {
            title: '账号管理'
          }
        },
        {
          path: '/role-permission-management',
          name: 'role-permission-management',
          component: rolePermissionManagement,
          meta: {
            title: '角色权限配置'
          }
        },
        {
          path: '/staff-role-list',
          name: 'staff-role-list',
          component: staffRoleList,
          meta: {
            title: '员工角色配置'
          }
        },
        {
          path: '/staff-role-configure',
          name: 'staff-role-configure',
          component: staffRoleConfigure,
          meta: {
            title: '员工角色配置维护界面'
          }
        },
        {
          path: '/staff-role-configure-shortcut',
          name: 'staff-role-configure-shortcut',
          component: staffRoleConfigureShortcut
        },
        {
          path: '/settings/password',
          name: 'setting-password',
          component: settingPassword,
          meta: {
            title: '修改密码'
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  let userToken = window.sessionStorage.getItem('SESSION_KEY_USER') &&
    JSON.parse(sessionStorage.getItem('SESSION_KEY_USER')).token
  if (to.path.includes('login')) {
    return next()
  }
  if (userToken) {
    const title = to.meta && to.meta.title
    if (title) {
      document.title = title
    } else {
      document.title = '保卫土豆'
    }
    next()
  } else {
    next('/login')
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js